.Select {
  display: flex;
  box-sizing: border-box;
  background-color: transparent;
  border-radius: 0.4rem;
  border: 0.1rem solid var(--color-grayscale-trout);
  font-size: 1.4rem;
  height: 3.2rem;
  min-height: 3.2rem;
  font-weight: 400;
  overflow: hidden;

  width: 100%;
  cursor: pointer;

  & > div:first-child {
    padding: 0.6rem 0.8rem;
    font-size: 1.4rem;
    color: var(--color-texts-low-contrast);
    width: 100%;

    &:hover {
      background-color: var(--color-surfaces-bg-elevation-3);
    }
  }

  & > div:last-child {
    padding: 0.6rem 0.8rem;
    color: var(--color-grayscale-shuttle);
  }

  &:hover {
    background-color: var(--color-surfaces-bg-elevation-3);

    & div {
      color: var(--color-texts-low-contrast);
    }
  }

  &[data-disabled='true'] {
    background: transparent;
    border-color: var(--color-texts-low-contrast);
  }
}
